/* Stroomkaart - translations: type pages (evenementen, indirect, laadpalen)
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Type-pagina's ----- */
  type_evenementen: {
    title: 'Direct inzetbare aansluitingen - Stroomkaart',
    eyebrow: 'Direct inzetbare aansluitingen',
    h1:      'Vaste stroompunten direct te gebruiken.',
    lede:    'Op diverse locaties zijn stroompunten aanwezig welke direct, zonder technische aanpassingen, ingezet kunnen worden. De stroompunten zijn veelal aanwezig op evenemententerreinen, markten of in en rondom havens.',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Waarom directe stroompunten.'
    },
    sec2: {
      eyebrow: 'Hoe je een punt in gebruik neemt',
      title: 'Drie manieren om een punt te activeren.',
      sub: 'Voor elk direct stroompunt geldt: je hebt toestemming van de eigenaar nodig (in veel gevallen de gemeente). Hoe je het punt vervolgens activeert, verschilt per locatie. Op de kaart zie je per punt welke route geldt.'
    },
    sec3: {
      eyebrow: 'De Stroomkaart-app',
      title: 'Gebruik een stroompunt met de Stroomkaart-app.',
      sub: 'Voor punten waar Stroomkaart als leverancier vermeld staat, kun je de hele activatie via de app uitvoeren. Hieronder de meest gebruikte instructies.'
    },
    sec4: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat gebruikers vaak willen weten.'
    },
    feat1: {
      title: 'Direct inzetbaar',
      body: 'Geen aanpassingen aan de installatie, geen wachten op een netaansluiting. Het punt staat er al en is bedoeld voor tijdelijk gebruik.'
    },
    feat2: {
      title: 'Vaak via een app te activeren',
      body: 'Veel punten zijn op afstand in te schakelen via een mobiele applicatie. Bij elk punt staat aangegeven welke leverancier de bediening verzorgt.'
    },
    feat3: {
      title: 'Vooraf duidelijk wat geldt',
      body: 'Voorwaarden, eventuele tarieven en een aanvullend aanmeldformulier staan vooraf bij het punt op de kaart. Geen verrassingen op locatie.'
    },
    route1: {
      eyebrow: 'Route 1',
      title:   'Aanvullend formulier',
      body:    'Sommige punten vragen een aanvullend formulier voor toestemming. Op die locaties staat een directe link naar het juiste aanmeldformulier bij het punt op de kaart, vaak van de gemeente of beheerder.',
    },
    route2: {
      eyebrow: 'Route 2',
      title:   'Mobiele (web)applicatie',
      body:    'Andere punten zijn in te schakelen via een mobiele (web)applicatie. De naam van de leverancier van die app staat bij het stroompunt vermeld. Aanvullende richtlijnen of tarieven van die leverancier kunnen van toepassing zijn.',
    },
    route3: {
      eyebrow: 'Route 3',
      title:   'De Stroomkaart-app',
      body:    'Voor punten waar Stroomkaart zelf de bediening verzorgt, gebruik je de Stroomkaart-app. De gebruikersinstructies staan onderaan deze pagina, onder andere voor het registreren, het aanzetten van een stroomkast en het openen van ondergrondse punten.',
    },
    toestemming: '<strong>Toestemming blijft de basis.</strong> Welke route je ook gebruikt: voor elk direct stroompunt is toestemming nodig van de eigenaar van het punt. In veel gevallen is dat de gemeente. Activering via een app of formulier regelt deze toestemming, maar zonder die stap kun je niet aansluiten.',
    instr1: {
      title: 'Voor het eerst registreren',
      body:  'Eenmalig je account aanmaken, organisatie koppelen en betaalwijze instellen. Daarna ben je klaar om punten in gebruik te nemen.',
    },
    instr2: {
      title: 'Een stroomkast aanzetten',
      body:  'Punt selecteren op de kaart, gebruiksperiode kiezen en de kast op afstand inschakelen. Stroom is direct beschikbaar.',
    },
    instr3: {
      title: 'Ondergrondse kast openen met een vierkante sleutel',
      body:  'Voor stroompunten die in een ondergrondse kast zitten. De app legt uit hoe je de kast met de bijbehorende vierkante sleutel veilig opent.',
    },
    instr4: {
      title: 'Een deur ontgrendelen via de app',
      body:  'Voor punten achter een afgesloten ruimte. De app stuurt na bevestiging het ontgrendel-signaal naar de juiste deur op locatie.',
    },
    instr_callout: '<strong>Welk type bediening hoort bij welk punt?</strong> Op de kaart staat per stroompunt aangegeven welke leverancier of methode geldt. Filter op evenementen-aansluitingen om alleen de directe stroompunten te zien.',
    faq: {
      q1: 'Wat is een direct stroompunt precies?',
      a1: 'Een aansluitpunt op de kaart dat direct gebruikt kan worden voor je evenement, bouwplaats of andere stroombehoefte, zonder dat er aanpassingen aan de installatie hoeven te worden gemaakt. De punten staan op vaste locaties (pleinen, parken, evenemententerreinen) en zijn meestal in beheer bij de gemeente.',
      q2: 'Heb ik altijd toestemming nodig om een punt te gebruiken?',
      a2: 'Ja. Voor elk direct stroompunt is toestemming nodig van de eigenaar - in veel gevallen de gemeente. Hoe je die toestemming krijgt verschilt per locatie: soms via een aanvullend formulier (waarvan de link bij het punt staat), soms direct via een app, soms via Stroomkaart zelf.',
      q3: 'Hoe weet ik welke app of methode bij een punt hoort?',
      a3: 'Op de kaart staat per stroompunt vermeld welke leverancier de bediening verzorgt. Als de Stroomkaart-app gebruikt kan worden, staat dat erbij. Voor andere apps geldt de naam van die specifieke leverancier - en die kan eigen richtlijnen of tarieven hanteren.',
      q4: 'Wat zijn de kosten?',
      a4: 'Dat hangt af van de eigenaar en de gebruikte bedieningsmethode. Bij gebruik van de Stroomkaart-app krijg je vooraf een prijsopgave. Bij andere apps gelden de tarieven van die leverancier - die staan vermeld bij het punt of in hun applicatie.',
      q5: 'Kan ik ook punten gebruiken die niet via de Stroomkaart-app gaan?',
      a5: 'Ja. Stroomkaart toont alle directe stroompunten, ook die door andere leveranciers worden bediend. Per punt staat aangegeven welke route je moet volgen - de Stroomkaart-app, een andere app, of een aanmeldformulier bij de gemeente.',
      q6: 'Wat als ik geen geschikt punt op mijn locatie zie?',
      a6: 'Teken op de kaart het gebied waar je stroom nodig hebt en geef je gewenste vermogen en periode op. Wij benaderen actief eigenaren en netbeheerders in dat gebied, ook punten die niet publiek op de kaart staan. Binnen twee weken krijg je een terugkoppeling met opties.',
    },
    cta_strip: {
      title:     'Bekijk de directe stroompunten op de kaart.',
      sub:       'Filter op evenementen-aansluitingen om alleen de direct beschikbare punten te zien.',
      primary:   'Open de kaart',
      secondary: 'Doe een aanvraag',
    },
  },
  type_indirect: {
    title: 'Indirecte stroompunten - Stroomkaart',
    eyebrow: 'Indirecte stroompunten',
    h1:      'Stroompunten die met een kleine aanpassing geschikt te maken zijn.',
    lede:    'Niet elk stroompunt op Stroomkaart is direct te gebruiken. Sommige aansluitingen hebben één of meer technische voorbereidingen nodig voordat ze daadwerkelijk stroom kunnen leveren - bijvoorbeeld het plaatsen van een meter, het bijbouwen van een aansluitkast of het schakelen van een ander vermogensniveau. Dit noemen we <strong>indirecte stroompunten</strong>. Ze staan op de kaart om zichtbaar te maken welke capaciteit met beperkte inspanning beschikbaar gemaakt kan worden, vaak veel sneller en goedkoper dan een volledig nieuwe netaansluiting.',
    cta_map_btn: 'Bekijk alle indirecte stroompunten op de kaart →',
    sec1: {
      eyebrow: 'Wat het oplevert',
      title: 'Waarom indirecte punten zichtbaar maken.'
    },
    sec2: {
      eyebrow: 'Type voorbereidingen',
      title: 'Wat voor aanpassingen kunnen nodig zijn.',
      sub: 'Op het detailblok van elk indirect punt staat precies welke voorbereiding gedaan moet worden, hoe lang dat naar verwachting duurt en wat de geschatte kosten zijn. De meest voorkomende soorten:'
    },
    sec3: {
      eyebrow: 'Het proces',
      title: 'Van aanvraag tot bruikbaar punt.',
      sub: 'Indirect activeren loopt anders dan een direct stroompunt - er zit altijd een korte voorbereidingsperiode tussen aanvraag en gebruik.'
    },
    sec4: {
      eyebrow: 'Veelgestelde vragen',
      title: 'Wat aanvragers vaak willen weten.'
    },
    feat1: {
      title: 'Sneller dan nieuwbouw',
      body: 'Een indirecte aansluiting bruikbaar maken kost vaak dagen tot weken - tegenover maanden of jaren wachttijd voor een nieuwe netaansluiting.'
    },
    feat2: {
      title: 'Aanzienlijk lagere kosten',
      body: 'De aanpassing zelf (een meter, een kast, een schakeling) kost een fractie van de aanlegkosten van een nieuwe aansluiting. Vaak betaalt de aanvrager de aanpassing en houdt het punt na afloop voor toekomstige gebruikers.'
    },
    feat3: {
      title: 'Inzicht in alle capaciteit',
      body: 'Door indirecte punten op de kaart op te nemen wordt zichtbaar waar overcapaciteit zit die met beperkte ingreep benut kan worden - cruciaal voor gemeenten en aannemers.'
    },
    opt1: {
      num: 'Type A',
      title: 'Meter plaatsen',
      effort: 'Doorlooptijd: 1-2 weken &middot; Lage kosten',
      body: 'De aansluiting bestaat fysiek maar er zit nog geen geschikte meter op. Een installateur plaatst een slimme tussenmeter zodat verbruik per gebruiker gemeten en gefactureerd kan worden.',
      li1: 'Voorbeeld: een direct te gebruiken CEE stopcontact aan de binnenzijde van een pand beschikt niet over een separate kWh-meter.',
      li2: 'Vereist een korte stroomonderbreking',
      li3: 'Daarna direct beschikbaar via de Stroomkaart-app'
    },
    opt2: {
      num: 'Type B',
      title: 'Aansluitkast bijbouwen',
      effort: 'Doorlooptijd: 2-4 weken &middot; Gemiddelde kosten',
      body: 'Het punt heeft de capaciteit, maar de bestaande kast heeft geen contactdozen die geschikt zijn voor de gevraagde toepassing. Een aansluitkast wordt naast of op het punt geplaatst.',
      li1: 'Voorbeeld: gemaal met aansluiting maar zonder CEE-aansluitcontact.',
      li2: 'Geschikt voor langer-lopende projecten',
      li3: 'Kast blijft staan voor toekomstige gebruikers'
    },
    opt3: {
      num: 'Type C',
      title: 'Vermogen schakelen',
      effort: 'Doorlooptijd: enkele dagen &middot; Beperkte kosten',
      body: 'De aansluiting heeft genoeg capaciteit, maar staat ingesteld op een te laag vermogen. De netbeheerder of installateur schakelt het toegestane vermogen omhoog (binnen de fysieke grenzen van de kabel).',
      li1: 'Voorbeeld: aansluiting van 32A naar 63A schakelen</li>\n<li>Vereist akkoord van de aansluitings&shy;eigenaar</li>\n<li>Soms een korte technische schouw vereist',
      li2: 'Vereist akkoord van de aansluitings&shy;eigenaar',
      li3: 'Soms een korte technische schouw vereist'
    },
    opt4: {
      num: 'Type D',
      title: 'Combinatie van aanpassingen',
      effort: 'Doorlooptijd: per geval &middot; Op offerte',
      body: 'Sommige punten vragen om een combinatie van bovenstaande - bijvoorbeeld meter plaatsen &eacute;n vermogen schakelen, of een complete kastvervanging. Voor deze punten maken we een offerte op maat.',
      li1: 'Voorbeeld: oude bouwaansluiting modernisering</li>\n<li>Werkt vaak via een gedeeld kostenmodel</li>\n<li>Pas geschikt voor projecten van enkele maanden',
      li2: 'Werkt vaak via een gedeeld kostenmodel',
      li3: 'Pas geschikt voor projecten van enkele maanden'
    },
    step1: {
      num: 'Stap 01',
      title: 'Selecteer punt op de kaart',
      body: 'Indirecte punten zijn op de kaart herkenbaar aan een eigen weergave. Op het detailblok zie je welke aanpassing nodig is, de geschatte doorlooptijd en de kosten.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Dien aanvraag met projectinformatie in',
      body: 'Geef aan vanaf wanneer je het punt nodig hebt, welk vermogen je gebruikt en hoe lang. We berekenen of de geplande aanpassing past binnen jouw planning.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Akkoord en aanpassing inplannen',
      body: 'Na akkoord op de offerte plannen we de installateur of netbeheerder in. Tijdens de werkzaamheden krijg je dagelijks status-updates.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Punt wordt actief en gebruiks&shy;klaar',
      body: 'Zodra de aanpassing afgerond is, schakelt het punt op de kaart van &quot;indirect&quot; naar &quot;beschikbaar&quot;. Je krijgt een mail met de activatie-instructies (app of sleutel).'
    },
    faq1: {
      q: 'Wie betaalt de aanpassing?',
      a: 'In de meeste gevallen de aanvrager - omdat die direct profiteert van de gemaakte capaciteit. Bij grotere aanpassingen die meerdere gebruikers ten goede komen, wordt soms een gedeeld kostenmodel toegepast (eerste gebruiker betaalt, latere gebruikers betalen een gereduceerd tarief gedurende de afschrijvings&shy;termijn).'
    },
    faq2: {
      q: 'Wat als ik het punt slechts korte tijd nodig heb?',
      a: 'Voor zeer korte gebruiksperioden (enkele dagen tot een week) is een indirect punt vaak niet rendabel - de aanpassingskosten wegen niet op tegen het verbruik. We adviseren dan een direct stroompunt elders, of zoeken een gemeente&shy;voorziening met overcapaciteit (zoals een evenementen-aansluiting) waarvoor geen aanpassing nodig is.'
    },
    faq3: {
      q: 'Kan ik de aanpassing zelf of via mijn eigen installateur laten doen?',
      a: 'Bij sommige aanpassingen ja - mits jouw installateur erkend is en werkt volgens NEN 1010 en de richtlijnen van de netbeheerder. Voor schakelingen van vermogen door de netbeheerder geldt dat dit altijd via de officiele instantie loopt. Bij aanvraag bespreken we welke route in jouw situatie kan.'
    },
    faq4: {
      q: 'Wat als de aanpassing technisch toch niet blijkt te kunnen?',
      a: 'Voor elke indirecte punt is een schouw uitgevoerd voordat het op de kaart komt - de aangegeven doorlooptijd en kosten zijn een realistische schatting. Mocht tijdens uitvoering blijken dat aanvullend werk nodig is, krijg je vooraf akkoord op de meerkosten of kun je kosteloos uit de aanvraag stappen.'
    },
    faq5: {
      q: 'Wij beheren stroompunten - kunnen wij indirecte punten ook aanmelden?',
      a: 'Ja. Voor gemeenten, havenbedrijven en netbeheerders is het juist waardevol om indirecte punten te tonen - het maakt zichtbaar welke capaciteit met beperkte inspanning gerealiseerd kan worden en helpt bij planning van toekomstige uitbreidingen. Bij aanmelding via <a href="aanmelden.html">Aansluiting aanmelden</a> kun je per punt aangeven of het direct of indirect is.'
    },
    lede_html: 'Niet elk stroompunt op Stroomkaart is direct te gebruiken. Sommige aansluitingen hebben &eacute;&eacute;n of meer technische voorbereidingen nodig voordat ze daadwerkelijk stroom kunnen leveren - bijvoorbeeld het plaatsen van een meter, het bijbouwen van een aansluitkast of het schakelen van een ander vermogensniveau. Dit noemen we <strong>indirecte stroompunten</strong>. Ze staan op de kaart om zichtbaar te maken welke capaciteit met beperkte inspanning beschikbaar gemaakt kan worden, vaak veel sneller en goedkoper dan een volledig nieuwe netaansluiting.',
    callout: '<strong>Goed om te weten:</strong> wie een indirect punt activeert, doet de hele markt een gunst. Het punt blijft na jouw project beschikbaar voor toekomstige gebruikers - vaak tegen een veel lager tarief.',
    schouw: '<strong>Technische schouw</strong> kan altijd benodigd zijn.',
    view_all_cta: 'Bekijk alle indirecte stroompunten op de kaart →',
    cta_strip: {
      title:     'Bekijk de directe stroompunten op de kaart.',
      sub:       'Filter op evenementen-aansluitingen om alleen de direct beschikbare punten te zien.',
      primary:   'Open de kaart',
      secondary: 'Doe een aanvraag',
    },
  },
  type_laadpalen: {
    title: 'Openbare laadpalen - Stroomkaart',
    eyebrow: 'Openbare laadpalen',
    h1:      'Laadinfrastructuur voor licht materieel en voertuigen.',
    lede:    'Voor wie elektrisch werkt op locatie: laadpalen op openbare plekken die ook voor licht bouwmaterieel, kleine voertuigen en EV-bedrijfswagens te gebruiken zijn.',
  },
};

export const en = {
  type_evenementen: {
    title: 'Ready-to-use connections - Stroomkaart',
    eyebrow: 'Ready-to-use connections',
    h1:      'Fixed power points ready to use.',
    lede:    'Various locations have power points that can be used directly, without any technical modifications. These points are typically located at event grounds, markets or in and around harbours.',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Why fixed event connections.'
    },
    sec2: {
      eyebrow: 'How to start using a point',
      title: 'Three ways to activate a point.',
      sub: 'For every direct power point: you need permission from the owner (in many cases the municipality). How you then activate the point varies per location and operator.'
    },
    sec3: {
      eyebrow: 'The Stroomkaart app',
      title: 'Use a power point with the Stroomkaart app.',
      sub: 'For points where Stroomkaart is listed as the supplier, you can carry out the entire activation via the app. Below the most-used instructions.'
    },
    sec4: {
      eyebrow: 'Frequently asked questions',
      title: 'What users often want to know.'
    },
    feat1: {
      title: 'No more renting generators',
      body: 'Connect to power at fixed event locations - no logistics around generators, fuel and noise. Cleaner site and lower costs.'
    },
    feat2: {
      title: 'Higher capacity available',
      body: 'Event connections are designed for high peak loads. Up to several hundred kVA per location, ideal for large stages, food trucks and lighting at once.'
    },
    feat3: {
      title: 'Predictable conditions',
      body: 'Same conditions per location, year after year. No new negotiations every season - one supply, one contract, recurring use.'
    },
    route1: {
      eyebrow: 'Route 1',
      title:   'Additional form',
      body:    'Some points require an additional form for permission. At those locations a direct link to the right form is shown next to the point on the map - typically from the municipality or operator.',
    },
    route2: {
      eyebrow: 'Route 2',
      title:   'Mobile (web) app',
      body:    'Other points can be switched on via a mobile (web) app. The name of the app provider is shown at the power point. Additional rules or rates from that provider may apply.',
    },
    route3: {
      eyebrow: 'Route 3',
      title:   'The Stroomkaart app',
      body:    'For points operated by Stroomkaart itself you use the Stroomkaart app. The user instructions are at the bottom of this page - including registration, switching a cabinet on and opening underground points.',
    },
    toestemming: '<strong>Permission stays the basis.</strong> Whichever route you use: for every direct power point you need permission from the owner. In many cases that is the municipality. Activation via an app or form arranges this permission, but without that step you cannot connect.',
    instr1: {
      title: 'Registering for the first time',
      body:  'One-off setup of your account, link the organisation and configure payment. After that you are ready to use points.',
    },
    instr2: {
      title: 'Switching on a power cabinet',
      body:  'Select a point on the map, choose the use period and remotely switch the cabinet on. Power is available right away.',
    },
    instr3: {
      title: 'Opening an underground cabinet with a square key',
      body:  'For power points inside underground cabinets. The app explains how to open the cabinet safely with the matching square key.',
    },
    instr4: {
      title: 'Unlocking a door via the app',
      body:  'For points behind a locked space. After confirmation the app sends the unlock signal to the correct on-site door.',
    },
    instr_callout: '<strong>Which type of operation belongs to which point?</strong> The map indicates per power point which provider or method applies. Filter on event connections to see only the direct power points.',
    faq: {
      q1: 'What exactly is a direct power point?',
      a1: 'A connection point on the map that can be used directly for your event, construction site or other power need, without changes to the installation. These points sit at fixed locations (squares, parks, event grounds) and are usually managed by the municipality.',
      q2: 'Do I always need permission to use a point?',
      a2: 'Yes. For every direct power point you need permission from the owner - in many cases the municipality. How you obtain that permission varies per location: sometimes via an additional form (link shown at the point), sometimes directly via an app, sometimes via Stroomkaart itself.',
      q3: 'How do I know which app or method belongs to a point?',
      a3: "The map shows per power point which provider operates the controls. If the Stroomkaart app can be used, that's noted. For other apps, the name of that specific provider applies - and they can use their own rules or rates.",
      q4: 'What are the costs?',
      a4: 'That depends on the owner and the operating method used. When using the Stroomkaart app you receive a quote upfront. With other apps, the rates of that provider apply - shown next to the point or in their app.',
      q5: 'Can I also use points that do not go via the Stroomkaart app?',
      a5: 'Yes. Stroomkaart shows all direct power points, including those operated by other providers. Per point it is shown which route to follow - the Stroomkaart app, another app, or a registration form via the municipality.',
      q6: 'What if I do not see a suitable point at my location?',
      a6: 'Draw the area where you need power on the map and provide your desired capacity and period. We actively approach owners and grid operators in that area, including points not publicly on the map. Within two weeks you receive a response with options.',
    },
    cta_strip: {
      title:     'View the direct power points on the map.',
      sub:       'Filter on event connections to see only the directly available points.',
      primary:   'Open the map',
      secondary: 'Submit a request',
    },
  },
  type_indirect: {
    title: 'Indirect power points - Stroomkaart',
    eyebrow: 'Indirect power points',
    h1:      'Power points available with a small adjustment.',
    lede:    'Not every power point on nrgmaps is directly usable. Some connections need one or more technical preparations before they can actually deliver electricity - for example installing a meter, adding a connection cabinet, or switching to a different capacity level. We call these <strong>indirect power points</strong>. They appear on the map to show where capacity can be unlocked with limited effort, often much faster and cheaper than a fully new grid connection.',
    cta_map_btn: 'View all indirect power points on the map →',
    sec1: {
      eyebrow: 'What it delivers',
      title: 'Why making indirect points visible matters.'
    },
    sec2: {
      eyebrow: 'Type of preparations',
      title: 'What kind of adjustments may be needed.',
      sub: 'On the detail panel of each indirect point you see exactly which preparation needs to be done, how long it is expected to take and the estimated cost. The most common types:'
    },
    sec3: {
      eyebrow: 'The process',
      title: 'From request to usable point.',
      sub: 'Activating indirectly works differently from a direct power point - there is always a short preparation period between request and use.'
    },
    sec4: {
      eyebrow: 'Frequently asked questions',
      title: 'What requesters often want to know.'
    },
    feat1: {
      title: 'Faster than new construction',
      body: 'Making an indirect connection usable typically takes days to weeks - versus months or years of waiting for a new grid connection.'
    },
    feat2: {
      title: 'Substantially lower costs',
      body: 'The adjustment itself (a meter, a cabinet, a switching) costs a fraction of the construction cost of a new connection. Often the applicant pays for the adjustment and keeps the point available for future users afterwards.'
    },
    feat3: {
      title: 'Insight into all capacity',
      body: 'By including indirect points on the map it becomes visible where spare capacity sits that can be tapped with limited intervention - crucial for municipalities and contractors in capacity-constrained areas.'
    },
    opt1: {
      num: 'Type A',
      title: 'Install meter',
      effort: 'Lead time: 1-2 weeks · Low cost',
      body: 'The connection physically exists but no suitable meter is installed yet. An installer places a smart sub-meter so consumption can be metered and invoiced per user.',
      li1: 'Example: an indoor CEE connector can be used directly after installing a kWh-meter',
      li2: 'Requires a brief power interruption',
      li3: 'Then directly available via the Stroomkaart app'
    },
    opt2: {
      num: 'Type B',
      title: 'Add connection cabinet',
      effort: 'Lead time: 2-4 weeks · Medium cost',
      body: 'The point has the capacity but the existing cabinet has no sockets suitable for the requested application. A connection cabinet is placed next to or on the point.',
      li1: 'Example: pumping station with connection but no CEE sockets',
      li2: 'Suitable for longer-running projects',
      li3: 'Cabinet stays in place for future users'
    },
    opt3: {
      num: 'Type C',
      title: 'Switch capacity',
      effort: 'Lead time: a few days · Limited cost',
      body: 'The connection has enough capacity but is set to a too-low capacity level. The grid operator or installer switches the permitted capacity up (within the physical limits of the cable).',
      li1: 'Example: connection from 32A to 63A',
      li2: 'Requires approval from the connection owner',
      li3: 'Sometimes a short technical survey is needed'
    },
    opt4: {
      num: 'Type D',
      title: 'Combination of adjustments',
      effort: 'Lead time: per case · By quotation',
      body: 'Some points require a combination of the above - for example installing a meter and switching capacity, or a complete cabinet replacement. For these points we make a custom quotation.',
      li1: 'Example: old construction connection modernisation',
      li2: 'Often works via a shared-cost model',
      li3: 'Best suited to projects of several months'
    },
    step1: {
      num: 'Step 01',
      title: 'Select point on the map',
      body: 'Indirect points are recognisable on the map by their own visual style. The detail panel shows which adjustment is needed, the estimated lead time and cost.'
    },
    step2: {
      num: 'Step 02',
      title: 'Submit request with project info',
      body: 'Indicate when you need the point, which capacity you use and how long. We calculate whether the planned adjustment fits your schedule.'
    },
    step3: {
      num: 'Step 03',
      title: 'Approval and adjustment scheduled',
      body: 'After approval of the quotation we schedule the installer or grid operator. During the work you receive daily status updates.'
    },
    step4: {
      num: 'Step 04',
      title: 'Point becomes active and ready to use',
      body: 'Once the adjustment is completed, the point switches from "indirect" to "available" on the map. You receive an email with the activation instructions (app or key).'
    },
    faq1: {
      q: 'Who pays for the adjustment?',
      a: 'In most cases the requester - because they directly benefit from the capacity made available. For larger adjustments that benefit multiple users a shared cost model is sometimes applied (first user pays, later users pay a reduced rate during the depreciation period).'
    },
    faq2: {
      q: 'What if I only need the point for a short time?',
      a: 'For very short use periods (a few days to a week) an indirect point is often not cost-effective - the adjustment costs do not outweigh the consumption. We then recommend a direct power point elsewhere, or look for a municipal facility with spare capacity (such as an event connection) that requires no adjustment.'
    },
    faq3: {
      q: 'Can I have the adjustment done myself or via my own installer?',
      a: 'For some adjustments yes - provided your installer is certified and works according to NEN 1010 and the grid operator\'s guidelines. For capacity switching by the grid operator it always runs through the official body. At the request stage we discuss which route applies in your situation.'
    },
    faq4: {
      q: 'What if the adjustment turns out not to be technically feasible?',
      a: 'For each indirect point an inspection is carried out before it is added to the map - the indicated lead time and cost are realistic estimates. If during execution it turns out additional work is needed, you receive prior approval for the extra cost or you can withdraw from the request free of charge.'
    },
    faq5: {
      q: 'We operate power points - can we register indirect points too?',
      a: 'Yes. For municipalities, port authorities and grid operators it is particularly valuable to show indirect points - it makes visible which capacity can be realised with limited effort and helps with planning future expansions. When registering via <a href="aanmelden.html">Register a connection</a> you can indicate per point whether it is direct or indirect.'
    },
    lede_html: 'Not every power point on Stroomkaart can be used directly. Some connections need one or more technical preparations before they can actually deliver power - for example installing a meter, adding a connection cabinet or switching to a different capacity level. We call these <strong>indirect power points</strong>. They appear on the map to show which capacity can be unlocked with limited effort, often much faster and cheaper than a fully new grid connection.',
    callout: '<strong>Good to know:</strong> activating an indirect point benefits the whole market. After your project the point stays available for future users - often at a much lower rate.',
    schouw: '<strong>Technical site visit</strong> may always be required.',
    view_all_cta: 'View all indirect power points on the map →',
    cta_strip: {
      title:     'View the direct power points on the map.',
      sub:       'Filter on event connections to see only the directly available points.',
      primary:   'Open the map',
      secondary: 'Submit a request',
    },
  },
  type_laadpalen: {
    title: 'Public EV chargers - Stroomkaart',
    eyebrow: 'Public EV chargers',
    h1:      'Charging infrastructure for light equipment and vehicles.',
    lede:    'For those who work electrically on location: charging stations in public places that can also be used for light construction equipment, small vehicles and EV company cars.',
  },
};
